"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { RatingStats } from "@/entities/IProfile";
import UserPageRepRepsTableBody from "./UserPageRepRepsTableBody";
import UserPageRepRepsTableHeader from "./UserPageRepRepsTableHeader";
import { SortDirection } from "@/entities/ISort";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import CommonTableWrapper from "@/components/utils/table/CommonTableWrapper";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export enum RepsTableSort {
  REP = "REP",
  RATERS = "RATERS",
  MY_RATES = "MY_RATES",
}
export default function UserPageRepRepsTable(t0) {
  const $ = _c(28);
  const {
    reps,
    profile,
    canEditRep
  } = t0;
  const [sortType, setSortType] = useState(RepsTableSort.REP);
  const [sortDirection, setSortDirection] = useState(SortDirection.DESC);
  let t1;
  if ($[0] !== sortType) {
    t1 = newSortType => {
      if (newSortType === sortType) {
        setSortDirection(_temp);
      } else {
        setSortType(newSortType);
        setSortDirection(SortDirection.DESC);
      }
    };
    $[0] = sortType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onSortTypeClick = t1;
  const compareValuesForSort = _temp2;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (items, sort, dir_0) => {
      switch (sort) {
        case RepsTableSort.REP:
          {
            return items.sort((a_2, d_2) => compareValuesForSort(a_2.rating, d_2.rating, dir_0));
          }
        case RepsTableSort.RATERS:
          {
            return items.sort((a_1, d_1) => compareValuesForSort(a_1.contributor_count, d_1.contributor_count, dir_0));
          }
        case RepsTableSort.MY_RATES:
          {
            return items.sort((a_0, d_0) => compareValuesForSort(a_0.rater_contribution, d_0.rater_contribution, dir_0, true));
          }
        default:
          {
            assertUnreachable(sort);
            return items;
          }
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const sortReps = t2;
  let t3;
  if ($[3] !== reps || $[4] !== sortDirection || $[5] !== sortType) {
    t3 = sortReps(reps, sortType, sortDirection);
    $[3] = reps;
    $[4] = sortDirection;
    $[5] = sortType;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const [sortedReps, setSortedReps] = useState(t3);
  let t4;
  let t5;
  if ($[7] !== reps || $[8] !== sortDirection || $[9] !== sortType) {
    t4 = () => {
      setSortedReps(sortReps(reps, sortType, sortDirection));
    };
    t5 = [reps, sortType, sortDirection];
    $[7] = reps;
    $[8] = sortDirection;
    $[9] = sortType;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[12] !== canEditRep || $[13] !== sortType) {
    t6 = () => {
      if (!canEditRep && sortType === RepsTableSort.MY_RATES) {
        setSortType(RepsTableSort.REP);
        setSortDirection(SortDirection.DESC);
      }
    };
    t7 = [canEditRep, sortType];
    $[12] = canEditRep;
    $[13] = sortType;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  if ($[16] !== canEditRep || $[17] !== onSortTypeClick || $[18] !== sortDirection || $[19] !== sortType) {
    t8 = <UserPageRepRepsTableHeader activeType={sortType} sortDirection={sortDirection} showMyRates={canEditRep} onSortTypeClick={onSortTypeClick} />;
    $[16] = canEditRep;
    $[17] = onSortTypeClick;
    $[18] = sortDirection;
    $[19] = sortType;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== canEditRep || $[22] !== profile || $[23] !== sortedReps) {
    t9 = <UserPageRepRepsTableBody reps={sortedReps} profile={profile} canEditRep={canEditRep} />;
    $[21] = canEditRep;
    $[22] = profile;
    $[23] = sortedReps;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t8 || $[26] !== t9) {
    t10 = <CommonTableWrapper>{t8}{t9}</CommonTableWrapper>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}
function _temp2(a, d, dir, t0) {
  const zeroAtEnd = t0 === undefined ? false : t0;
  if (!zeroAtEnd) {
    return dir === SortDirection.DESC ? d - a : a - d;
  }
  if (a === 0 && d === 0) {
    return 0;
  } else {
    if (a === 0) {
      return 1;
    } else {
      if (d === 0) {
        return -1;
      }
    }
  }
  return dir === SortDirection.DESC ? d - a : a - d;
}
function _temp(prev) {
  return prev === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
}